module.exports = "### CrewTracker\n\n- Space deliveries are dangerous\n\n- Need to know who's part of the crew and who needs to be replaced\n\n- Implement UI by breaking into chunks\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/11_composition/notes_2.md
// module id = 1530
// module chunks = 0